module.exports = __webpack_public_path__ + "assets/img/xyzq.71343027.png";